module.exports = __webpack_public_path__ + "static/media/montserrat-latin-200-normal.2df8cec1.woff";